export default __webpack_public_path__ + "static/media/medical_cases.2fa8ce46.svg";